import styled from 'styled-components'

let SimpleFooter = styled.div`
    padding: 10px 0; 
    text-align: center;
    vertical-align: center;
    background-color: black;
    padding: 20px;
    color: white;
`

export default SimpleFooter 